<template>
	<div class="container">
		<div v-if="!isActive" class="inactive">
			<h1>sorry, this page is still at stage 1</h1>
		</div>
		<div v-else>
			<h1>contact.</h1>
			<p>Please connact me with any business inquiries.</p>
			<form autocomplete="off">
				<ul>
					<li>
						<label for="name">name</label>
						<input class="name" type="text" id="name" name="user_name" placeholder="full name">
					</li>
					<li>
						<label for="email">email</label>
						<input class="email" type="email" id="email" name="user_email" placeholder="email">
					</li>
					<li>
						<label for="message">message</label>
						<textarea class="message" id="message" name="user_message" placeholder="message for Tyler..."></textarea>
					</li>
					<li>
						<button class="submit-button" type="submit">submit</button>
					</li>
				</ul>
			</form>
		</div>
	</div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
	name: 'Contact',
	setup() {
		const store = useStore();
		const isActive = computed(() => {
			console.log(store.state.toggle)
			return store.state.toggle.contactPage
		});

		return {
			isActive
		}
	}
}
</script>

<style scoped>

.inactive {
	position: relative;
	top: 25vh;
}

input {
	background: black;
	color: white;
	border: none;
	border-radius: 10pt;
	margin: 0;
	padding: 0 0 0 15pt;
	height: 25pt;
	width: 250pt;
}

input:focus {
	outline: none;
	border-color: #9ecaed;
	box-shadow: 0 0 10px #9ecaed;
}

.message {
	background: black;
	color: white;
	border: none;
	border-radius: 10pt;
	padding: 15pt;
	font-family: Arial, Helvetica, sans-serif;
}

.message:focus {
	outline: none;
	border-color: #9ecaed;
	box-shadow: 0 0 10px #9ecaed;
}

.submit-button {
	background: black;
	color: white;
	border: none;
	border-radius: 10pt;
	padding: 10pt 20pt;
	cursor: pointer;
	transition: 0.4s;
}

.submit-button:hover {
	background: white;
	color: black;
}

ul {
	padding: 0;
	margin: 0;
}

li {
	margin: 10pt 0;
	list-style-type: none;
}

label {
	margin: 5pt 10pt;
	display: block;
}

input {
	width: 150pt;
}

textarea {
	width: 200pt;
	min-height: 75pt;
}

@media (max-height: 900px) {
	.inactive {
		top: 10vh;
		left: 5vw;
		width: 90%;
	}
}
</style>